export default {
    setCurrentUserinfo(state, payload) {
        if ("username" in payload){
            state.loggedInUser = payload.username
        }
        state.loggedInUserInfo = payload
        state.loggedInUserId = payload._id
    },
    unsetUserinfo(state) {
        state.loggedInUser = null
        state.loggedInUserInfo = {}
        state.loggedInUserId = null
    },
    setMetadataDockState(state, changedState) {
        state.isMetadataDockVisible = changedState;
    },
    setAssetDetailsPanelState(state, changedState) {
        if (changedState){
            state.isMiniplayerVisible = false
            state.selectedPlayerPanel = "assetPanel"
        }
        state.isAssetsDetailsPanelVisible = changedState
    },
    setMiniplayerState(state, changedState) {
        if (changedState){
            state.isAssetsDetailsPanelVisible = false
            state.selectedPlayerPanel = "miniPlayerPanel"
        }
        state.isMiniplayerVisible = changedState
    },
    setClientIp(state, ip){
        if (ip){
            state.ip = ip
        }
    },
    setAllUsersBasicInfoIntoTheStore(state, usersBasicInfo){
        if (!Array.isArray(usersBasicInfo)) {
            console.error("Mutation received invalid data: expected an array of users.");
            return;
        }
    
        const usersMap = usersBasicInfo.reduce((acc, user) => {
            acc[user._id] = {
                _id: user._id,
                username: user.username, 
                profile_image: user.profile_image || null,
            };
            return acc;
        }, {});
    
        state.usersBasicInfo = usersMap;
    },

};